export default function(/**@type {ApisauceInstance} */ api) {
    const getAllQuestionsTypes = () => api.get("Lookups/questions-types");

    return {
      lookups: {
        getAllQuestionsTypes, 
      },
    };
  }